import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }   from '@angular/forms';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { AppRoutingModule } from './app.routing.module';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TextMaskModule } from 'angular2-text-mask';

import { MomentModule } from 'angular2-moment';

import { AppComponent } from './app.component';

import { SskRoutesModule } from './routes/ssk.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    SskRoutesModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    TextMaskModule
  ],
  providers: [],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/app.module.ts